export const getProductContractGroups = state => state.admin.productContractGroups;

export const getProductContractGroupsData = state => getProductContractGroups(state).data;
export const getProductsCount = state => getProductContractGroups(state).totalProducts;

export const getProductContractGroupById = (state, groupId) =>
  getProductContractGroupsData(state).find(({ id }) => id === groupId);
